export default __webpack_public_path__ + "static/media/Symbol-full-colour.b6e87882.png";